module.exports = __webpack_public_path__ + "static/media/ruoppaukset-1.6bf5e1dc.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/ruoppaukset-1.JPG
// module id = 36
// module chunks = 0